import { render, staticRenderFns } from "./Toc.vue?vue&type=template&id=fb5cc4a2&"
import script from "./Toc.vue?vue&type=script&lang=js&"
export * from "./Toc.vue?vue&type=script&lang=js&"
import style0 from "./Toc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Toc.vue
// module id = 1022
// module chunks = 0